module.exports = __webpack_public_path__ + "static/img/director_02.acab47a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2022/corona/director_02.png
// module id = HFnn
// module chunks = 0